export default {
    'fumigation-certificates': 'Fumigation certificates',
    'fumigation-certificate': 'fumigation certificate',
    'add-a-fumigation-certificate': 'Add a fumigation certificate',
}